import { FC } from "react";
import cx from "classnames";

import Button from "./../Button";
import { IconTypes } from "./../Icon";

import styles from "./styles.module.scss";

interface IProps {
    checked: boolean;
    onChange: () => void;
    label?: any;
    className?: string;
    labelClassName?: string;
    name?: string;
}

const Radio: FC<IProps> = ({ checked, onChange, label, className, labelClassName, name }) => {
    return (
        <div className={cx(styles.radio, { [className!!]: className })} onClick={onChange}>
            <input type="radio" checked={checked} onChange={onChange} name={name} />
            <label>
                <Button
                    className={styles.icon}
                    icon={checked ? IconTypes.RADIO_BUTTON : IconTypes.CIRCLE_UNDEFILLED}
                    iconSize={20}
                />
                <span className={cx({ [labelClassName!!]: labelClassName })}>{label}</span>
            </label>
        </div>
    );
};

export default Radio;
